import packageInfo from '../../../package.json';
import { DynamicObject } from '../../utils/commonTypes';
import { TRANSLATION_DOMAIN } from '../../utils/constants/ApiConstants';
import { HTTP_METHODS } from '../../utils/constants/HttpMethodsConstants';
import { HttpService } from '../fetch/HttpService';

const httpService = new HttpService();

const translationsList = [
  `subscription`,
  `header`,
  `footer`,
  `login-register`,
  `fallback`,
  'consumption',
  'plex',
  'celebs',
  'tvshowdetails',
  'episodes',
  'aggregator'
];

const S3TranslationFlag = process.env.NEXT_PUBLIC_S3_TRANSLATION;

// when isServerSide is true it will load translations from local files else from S3
export const getTranslations = async (locale = 'en', isServerSide = false) => {
  const loadLocalTranslation = async (file: string) => {
    return await import(
      `../../../public/webapp-translations/${file}/z5-strings-${file}-${locale}.json`
    );
  };

  const loadS3Translation = async (file: string) => {
    try {
      const data = await httpService.fetchApiData({
        url: `${TRANSLATION_DOMAIN}${packageInfo.version}/${file}/z5-strings-${file}-${locale}.json`,
        type: HTTP_METHODS.GET,
        noAuthHeaderFlag: true
      });
      /**
       * NOTE: If for some reason we don't find translation file (HTTP code: 404, etc), it sends response in the following format:
       * { "url": "https://playerscript.zee5.com/webapp-translation/4.0.5/subscription/z5-strings-en.json",
       *   errData: undefined,
       *   responseData: undefined
       * }
       * The above response is our own formed in httpservice file
       * Otherwise, it sends json file content directly in data.
       *
       */
      if (data.url) {
        return loadLocalTranslation(file);
      }
      if (data) {
        return data;
      }
    } catch (error) {
      console.error(`Error calling API (${file}):`, error);
      // Retry the failed API call
      return loadLocalTranslation(file);
    }
  };

  const [
    translations,
    header,
    footer,
    loginRegister,
    fallback,
    consumption,
    plex,
    celebs,
    tvshowdetails,
    episodes,
    aggregator
  ] = await Promise.all(
    translationsList.map((translationFile) =>
      !isServerSide &&
      S3TranslationFlag &&
      JSON.parse(S3TranslationFlag as string)
        ? loadS3Translation(translationFile)
        : loadLocalTranslation(translationFile)
    )
  );

  const common = { ...header, ...footer };
  return {
    subscription: translations.COMMON,
    common,
    loginRegister: { ...loginRegister },
    fallback: { ...fallback },
    consumption: { ...consumption },
    plex,
    celebs,
    tvshowdetails,
    episodes,
    aggregator
  };
};

export const isTranslationDifferent = (
  newTranslation: DynamicObject,
  oldTranslation: DynamicObject
) => {
  if (
    Object.keys(newTranslation).length !== Object.keys(oldTranslation).length
  ) {
    return true;
  }

  return Object.keys(newTranslation).some((key: string) => {
    const newValue = newTranslation[key];
    const oldValue = oldTranslation[key];

    try {
      if (oldValue.default) {
        delete oldValue.default;
      }
    } catch (error) {
      console.log('something went wrong while deleting default obj', error);
    }

    if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
      return true;
    }
  });
};
